import { fetchAppExternalAwsRdsConnectionsByExternalAwsResourceId } from "@app/deploy";
import { useQuery } from "@app/react";
import { useParams } from "react-router";
import { AppListByExternalAwsResource } from "../shared/app";

export const ExternalAwsResourceDetailsPage = () => {
  const { id } = useParams<{ id: string }>();

  useQuery(
    fetchAppExternalAwsRdsConnectionsByExternalAwsResourceId({
      resourceId: id || "",
    }),
  );

  if (!id) {
    return <div>Resource not found</div>;
  }

  return <AppListByExternalAwsResource resourceId={id} />;
};
